<template>
  <div class="docs__menu">
    <ul class="docs__menu-items">
      <li
        v-for="item in menu"
        :key="item.name"
        class="docs__menu-item"
        :class="{ 'docs__menu-item--open': item.open }"
      >
        <a class="docs__menu-item-link" @click="item.open = !item.open">
          {{ item.name }}
        </a>

        <ul class="docs__menu-sub">
          <li
            v-for="child in item.children"
            :key="child[slugPropertyName]"
            class="docs__menu-sub-item"
            :class="{
              'docs__menu-sub-item--active': child[slugPropertyName] === slug,
            }"
          >
            <nuxt-link class="docs__menu-sub-link" :to="getRoutePath(child)">{{
              child.name
            }}</nuxt-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DocsMenu',
  props: {
    menu: {
      type: Array,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    slugPropertyName: {
      type: String,
      required: false,
      default: 'slug',
    },
  },
  methods: {
    getRoutePath(child) {
      if (child.path)
        return { name: this.$route.name, params: { path: child.path } }
      else if (child.slug)
        return { name: this.$route.name, params: { slug: child.slug } }
    },
  },
}
</script>
